"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

//Propiedades del paquete React grid layout para ser modificados
var GridLayoutAtributes = function GridLayoutAtributes(_ref) {
  var properties = _ref.properties,
      handlePropertyChange = _ref.handlePropertyChange,
      handleItemAttribute = _ref.handleItemAttribute;
  var useStyles = (0, _styles.makeStyles)(function () {
    return {
      marginBottom: {
        marginBottom: 20
      },
      formLabel: {
        fontSize: 12,
        marginTop: 3
      },
      colorPicker: {
        width: "100%",
        marginTop: ".2rem",
        marginBottom: "1rem"
      },
      label1: {
        textAlign: "center",
        marginBottom: "10%"
      }
    };
  });
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_core.Typography, {
    className: classes.label1,
    color: "textSecondary",
    display: "block",
    variant: "caption"
  }, "Los valores de altura y anchura estan expresados en numero de columnas"), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Altura",
    value: properties.h,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "h", Number(e.target.value));
    },
    className: classes.marginBottom
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Minima altura",
    value: properties.minH,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "minH", Number(e.target.value));
    },
    className: classes.marginBottom
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Maxima altura",
    value: properties.maxH,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "maxH", Number(e.target.value));
    },
    className: classes.marginBottom
  }))), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Anchura",
    value: properties.w,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "w", Number(e.target.value));
    },
    className: classes.marginBottom
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Min anchura",
    value: properties.minW,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "minW", Number(e.target.value));
    },
    className: classes.marginBottom
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Max anchura",
    value: properties.maxW,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "maxW", Number(e.target.value));
    },
    className: classes.marginBottom
  }))), /*#__PURE__*/React.createElement(_core.Typography, {
    className: classes.label1,
    color: "textSecondary",
    display: "block",
    variant: "caption"
  }, "Posiciones:"), /*#__PURE__*/React.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Horizontal",
    value: properties.x,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "x", Number(e.target.value));
    },
    className: classes.marginBottom
  })), /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(_core.TextField, {
    type: "number",
    label: "Vertical",
    value: properties.y,
    onChange: function onChange(e) {
      handlePropertyChange(properties, "y", Number(e.target.value));
    },
    className: classes.marginBottom
  }))));
};

var _default = GridLayoutAtributes;
exports.default = _default;